/** Typed decimal text: 1-3 digits, then at most one "," or "." and `maxDecimals` digits (a bare "," is blocked). */
const isAllowedDecimal = (raw: string, maxDecimals = 1): boolean =>
  new RegExp(`^(\\d{1,3}([.,]\\d{0,${maxDecimals}})?)?$`).test(raw);

/** The keystroke result when it is allowed, else the previous value (blocks letters, symbols, a second separator). */
export const sanitizeDecimal = (raw: string, previous: string, maxDecimals = 1): string =>
  isAllowedDecimal(raw, maxDecimals) ? raw : previous;

/** Comma to dot, so "84,5" is stored and parsed as 84.5; a separator still being typed ("84,") is dropped. */
export const normalizeDecimal = (raw: string): string => raw.trim().replace(",", ".").replace(/\.$/, "");

/** Number shown back in the user's locale ("179,5" in DE), no thousands separator. */
export const formatDecimal = (value: number, language = "de", maxDecimals = 1): string =>
  value.toLocaleString(language, { maximumFractionDigits: maxDecimals, useGrouping: false });
